import {hash} from '@wandb/weave/core/model/graph/editing/hash';

/**
 * The purpose of this function is to generate a stable digest of an object.
 * This is useful for identifying objects that are the same, even if they are not
 * strictly equal. This is used to generate digests from the inputs_dump of a call
 * to group imperative evaluation predict and score calls by input.
 */
export const generateStableDigest = (obj: any): string => {
  if (obj === undefined || obj === null) {
    return 'null';
  }

  try {
    const sortObjectKeys = (val: any): any => {
      if (val === null || val === undefined) {
        return null;
      }

      if (typeof val !== 'object' || Array.isArray(val)) {
        return val;
      }

      return Object.keys(val)
        .sort()
        .reduce((result: any, key) => {
          result[key] = sortObjectKeys(val[key]);
          return result;
        }, {});
    };

    return hash(JSON.stringify(sortObjectKeys(obj)));
  } catch (e) {
    console.warn('Error generating stable digest:', e);
    return `digest_${Date.now()}`;
  }
};
